/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Contract_Duration_MonthsInputs */

const en_clients_field_contract_duration_months = /** @type {(inputs: Clients_Field_Contract_Duration_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duration (months)`)
};

const pt_br2_clients_field_contract_duration_months = /** @type {(inputs: Clients_Field_Contract_Duration_MonthsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração (meses)`)
};

/**
* | output |
* | --- |
* | "Duration (months)" |
*
* @param {Clients_Field_Contract_Duration_MonthsInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_contract_duration_months = /** @type {((inputs?: Clients_Field_Contract_Duration_MonthsInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Contract_Duration_MonthsInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_contract_duration_months(inputs)
	return pt_br2_clients_field_contract_duration_months(inputs)
});